import React from 'react';
import { Link } from 'react-router-dom';
import CollapseHeader from '../../../core/common/collapse-header/collapse-header';

const MyCoverage = () => {
    return (
        <div className="page-wrapper " id='myCoverages'>
            <div className="content">
                {/* Breadcrumb */}
                <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                    <div className="my-auto mb-2">
                        <h2 className="mb-1">My Coverages</h2>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/employee-dashboard">
                                        <i className="ti ti-smart-home" />
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    My Coverages
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                        <div className="head-icons ms-2">
                            <CollapseHeader />
                        </div>
                    </div>
                </div>
                {/* /Breadcrumb */}

                <div className="card p-5 shadow-sm">
                    <p className='text-center fs-20 para'>
                        For now, you are not a part of Team1’s health insurance plan.
                        If you want to become a member for the same, please click on the below link to know your eligibility.
                    </p>
                    <Link
                        to="/premium-eligibility"
                        className="btn btn-primary custom_button mt-3"
                    >
                        Premium Eligibility
                    </Link>
                </div>
            </div>
            <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
                <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>

            </div>
        </div>
    );
};

export default MyCoverage;
